import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SECOND } from '@gelato-api-ui/utils/time';

@Component({
  selector: 'gd-product-template-name-search-field',
  templateUrl: './product-template-name-search-field.component.html',
  styleUrls: ['./product-template-name-search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplateNameSearchFieldComponent {
  @Input() set templateName(templateName: string) {
    this.templateName$.next(templateName);
  }

  @Output() templateNameChange = new EventEmitter<string>();

  templateName$ = new BehaviorSubject<string>(null);
  templateNameChangeTimer = null;

  onTemplateNameChange(templateName: string) {
    this.templateName$.next(templateName);
    this.initTemplateNameChangeTimer();
  }

  private clearTemplateNameChangeTimer() {
    clearTimeout(this.templateNameChangeTimer);
  }

  private initTemplateNameChangeTimer() {
    this.clearTemplateNameChangeTimer();
    this.templateNameChangeTimer = setTimeout(() => {
      this.emitTemplateNameChangeEvent();
    }, SECOND);
  }

  private emitTemplateNameChangeEvent() {
    this.templateNameChange.emit(this.templateName$.getValue());
  }
}
